import HTTPClient from './http-client';

const END_POINT = '/flowdurationcurve';

const loadFlowDurationCurve = async ({location_id}) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(
    `${END_POINT}?location_id=${location_id}`
  );
}

export {
  loadFlowDurationCurve
}
